var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 56,
    viewBox: "0 0 227 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_438_2585",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.773 10L113 0L107.227 10H23C10.2975 10 0 20.2975 0 33C0 45.7025 10.2974 56 23 56H204C216.703 56 227 45.7025 227 33C227 20.2975 216.703 10 204 10H118.773Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.773 10L113 0L107.227 10H23C10.2975 10 0 20.2975 0 33C0 45.7025 10.2974 56 23 56H204C216.703 56 227 45.7025 227 33C227 20.2975 216.703 10 204 10H118.773Z",
    fill: "#1B1B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 0L113.866 -0.5L113 -2L112.134 -0.5L113 0ZM118.773 10L117.907 10.5L118.196 11H118.773V10ZM107.227 10V11H107.804L108.093 10.5L107.227 10ZM112.134 0.5L117.907 10.5L119.64 9.5L113.866 -0.5L112.134 0.5ZM108.093 10.5L113.866 0.5L112.134 -0.5L106.36 9.5L108.093 10.5ZM23 11H107.227V9H23V11ZM1 33C1 20.8497 10.8497 11 23 11V9C9.74517 9 -1 19.7452 -1 33H1ZM23 55C10.8497 55 1 45.1503 1 33H-1C-1 46.2548 9.74516 57 23 57V55ZM204 55H23V57H204V55ZM226 33C226 45.1503 216.15 55 204 55V57C217.255 57 228 46.2548 228 33H226ZM204 11C216.15 11 226 20.8497 226 33H228C228 19.7452 217.255 9 204 9V11ZM118.773 11H204V9H118.773V11Z",
    fill: "url(#paint0_linear_438_2585)",
    mask: "url(#path-1-inside-1_438_2585)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_2585",
    x1: 2.57955,
    y1: 28,
    x2: 223.389,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FEEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientTooltip);
export default __webpack_public_path__ + "static/media/GradientTooltip.846e189d994b6a89ec8f495a7af00f15.svg";
export { ForwardRef as ReactComponent };